module.exports = __webpack_public_path__ + "img/table.9616b962.png";